import { transformComponent } from '../../__builtins__/shared'
import { connect, mapProps, mapReadPretty } from '@formily/vue'

import { Input as RichInputNumber } from '@didi/rich-ui'
import { InputPreviewText } from '../PreviewText'

const TransformElInputNumber = transformComponent(
  RichInputNumber,
  {
    change: 'input'
  }
)

export const InputNumber = connect(
  TransformElInputNumber,
  mapProps({ readOnly: 'readonly' }, (props) => {
    let controlsPosition = 'right'
    if (props.controlsPosition) {
      controlsPosition = props.controlsPosition
    }
    return {
      controlsPosition,
      type: 'number'
    }
  }),
  mapReadPretty(InputPreviewText)
)

export default InputNumber
